import service from '@/utils/server';

const modName='/bd/orderQuery/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};
//查询详情
export const orderDetail = data => {
  return service({
    url: modName + 'orderDetail',
    method: 'post',
    data
  });
};

//导出文件方法
export const getExportData = data => {
  let config = {
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

//删除方法
export const deleteData = data => {
  return service({
    url: modName+'delete/'+data,
    method: 'post'
  })
};

//查詢运单信息
export const orderClose = data => {
  return service({
    url: modName+'orderClose',
    method: 'post',
    data
  })
};

//订单复制
export const orderCopy = data => {
  return service({
    url: modName+'orderCopy/'+data,
    method: 'post'
  })
};

//下载采购单PDF
export const orderPdfDownload = data => {
  return service({
    url: modName+'orderPdfDownload/'+data,
    method: 'post',
    responseType: "blob"
  })
};

//sap重推
export const repeatPushSap = data => {
  return service({
    url: modName+'repeatPushSap/'+data,
    method: 'post'
  })
};

/**
 * 初始化特殊地址
 */
export const initSpecialAddressData= data => {
  return service({
    url: modName+'specialAddressEdit',
    method: 'post',
    data
  })
};
/**
 * 新增特殊地址提交
 * @param data
 * @returns {*}
 */
export const addSpecialAddressSubmit= data => {
  return service({
    url: modName+'specialAddressSubmit',
    method: 'post',
    data
  })
};



// WEBPACK FOOTER //
// ./src/page/order/search/api/index.js